// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGWebsite = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsx("path", {
    fillOpacity: 0.01,
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M13.6 1.5H2.4C1.075 1.5 0 2.575 0 3.9v8c0 1.325 1.075 2.4 2.4 2.4h11.2c1.325 0 2.4-1.075 2.4-2.4v-8c0-1.325-1.075-2.4-2.4-2.4zM5.867 3.676v-.085c0-.271.22-.491.49-.491h.086c.27 0 .49.22.49.49v.086c0 .27-.22.49-.49.49h-.086c-.27 0-.49-.22-.49-.49zM4.309 3.1c.271 0 .491.22.491.49v.086c0 .27-.22.49-.49.49h-.086c-.27 0-.49-.22-.49-.49v-.085c0-.271.22-.491.49-.491h.085zM1.6 3.75l-.002-.037c0-.013 0-.026.002-.039v.002-.085c0-.271.22-.491.49-.491h.086l.037-.002c.014 0 .026 0 .04.002H2.25c.236.035.416.237.416.48v.096c0 .27-.22.49-.491.49h-.095c-.244 0-.446-.18-.48-.413L1.6 3.751zm12.8 8.15c0 .442-.358.8-.8.8H2.4c-.442 0-.8-.358-.8-.8V5.767h12.8V11.9z"
  })]
}));
SVGWebsite.displayName = 'SVGWebsite';
export default SVGWebsite;